import { useSyncExternalStore } from 'react';

export type ThemePreference = 'system' | 'light' | 'dark';

const STORAGE_KEY = 'theme';
const listeners = new Set<() => void>();

function readStoredPreference(): ThemePreference {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === 'light' || stored === 'dark' ? stored : 'system';
  } catch {
    return 'system';
  }
}

let preference = readStoredPreference();

function storePreference(newPreference: ThemePreference) {
  try {
    if (newPreference === 'system') {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, newPreference);
    }
  } catch {}
}

function applyPreference(newPreference: ThemePreference) {
  if (newPreference === 'system') {
    delete document.documentElement.dataset.theme;
  } else {
    document.documentElement.dataset.theme = newPreference;
  }
}

export function setThemePreference(newPreference: ThemePreference) {
  preference = newPreference;
  storePreference(newPreference);
  applyPreference(newPreference);
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

export function useThemePreference() {
  return useSyncExternalStore(subscribe, () => preference);
}
